"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YoutubeVideo1Schema = void 0;
exports.YoutubeVideo1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/youtube-video/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "YoutubeVideo1",
    "description": "Embed a youtube video",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:youtube-video:1"
            ]
        },
        "attributes": {
            "type": "object",
            "anyOf": [
                {
                    "required": [
                        "playlistId"
                    ]
                },
                {
                    "required": [
                        "videoId"
                    ]
                }
            ],
            "properties": {
                "playlistId": {
                    "type": "string",
                    "description": "The playlist from which the video should be played ('list=' parameter)"
                },
                "videoId": {
                    "type": "string",
                    "description": "The video ID of a youtube video. (not the youtube URL!) See https://www.google.at/?q=Youtube+video+id"
                },
                "timeOffsetInSeconds": {
                    "type": "integer",
                    "description": "The time offset in seconds from which the video should be played. ('t=' parameter)"
                }
            }
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy95b3V0dWJlLXZpZGVvLzEuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsbUJBQW1CLEdBQUc7SUFDakMsS0FBSyxFQUFFLGtGQUFrRjtJQUN6RixTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSxlQUFlO0lBQ3hCLGFBQWEsRUFBRSx1QkFBdUI7SUFDdEMsTUFBTSxFQUFFLFFBQVE7SUFDaEIsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFO2dCQUNOLDBDQUEwQzthQUMzQztTQUNGO1FBQ0QsWUFBWSxFQUFFO1lBQ1osTUFBTSxFQUFFLFFBQVE7WUFDaEIsT0FBTyxFQUFFO2dCQUNQO29CQUNFLFVBQVUsRUFBRTt3QkFDVixZQUFZO3FCQUNiO2lCQUNGO2dCQUNEO29CQUNFLFVBQVUsRUFBRTt3QkFDVixTQUFTO3FCQUNWO2lCQUNGO2FBQ0Y7WUFDRCxZQUFZLEVBQUU7Z0JBQ1osWUFBWSxFQUFFO29CQUNaLE1BQU0sRUFBRSxRQUFRO29CQUNoQixhQUFhLEVBQUUsd0VBQXdFO2lCQUN4RjtnQkFDRCxTQUFTLEVBQUU7b0JBQ1QsTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLGFBQWEsRUFBRSx1R0FBdUc7aUJBQ3ZIO2dCQUNELHFCQUFxQixFQUFFO29CQUNyQixNQUFNLEVBQUUsU0FBUztvQkFDakIsYUFBYSxFQUFFLG9GQUFvRjtpQkFDcEc7YUFDRjtTQUNGO0tBQ0Y7SUFDRCxVQUFVLEVBQUU7UUFDVixZQUFZO1FBQ1osTUFBTTtLQUNQO0NBQ0YsQ0FBQSJ9